
<tilby-dialog-toolbar (confirm)="confirm()" [disabled]="isDisableConfirmButton"/>
<tilby-dialog-content>
    <form>
        <mat-form-field class="tw-w-full">
            <mat-label>Email</mat-label>
            <input type="email" matInput [formControl]="emailFormControl" [errorStateMatcher]="matcher" placeholder="Inserire email">
            
            @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
                <mat-error>{{"CUSTOMERS.TOPBAR.ACTIONS.INSERT_VALID_EMAIL" | translate}}</mat-error>
            }
            @if (emailFormControl.hasError('required')) {
                <mat-error>{{"CUSTOMERS.TOPBAR.ACTIONS.MANDATORY_EMAIL" | translate}}</mat-error>
            }
        </mat-form-field>
    </form>
</tilby-dialog-content>

